// extracted by mini-css-extract-plugin
export default {"underline":"style_underline__t-8us"};